module.exports = __webpack_public_path__ + "static/img/logo-title@2x.b1d9287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-title@2x.png
// module id = HRFm
// module chunks = 2